import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import toast, { Toaster } from 'react-hot-toast';
import { API_URL } from '../config/api';

const CLOUD_NAME = "ds3eogn8u";
const UPLOAD_PRESET = "codeshop_upload";

async function uploadToCloudinary(file) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', UPLOAD_PRESET);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, {
    method: 'POST',
    body: formData,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error?.message || 'Erreur upload Cloudinary');
  return data.secure_url;
}

export default function ModifierArticle() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    reference: '',
    title: '',
    description: '',
    price: '',
    prixOriginal: '',
    label: '',
    categorie: '',
    details: '',
    prixAchat: '',
    groupe: '',
    stock: 0,
    disponible: true,
    promotion: 0,
    videoUrl: '',
    nouveaute: true,
    images: [],
    img: ''
  });

  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState('');
  const [secondaryFiles, setSecondaryFiles] = useState([]);
  const [secondaryPreviews, setSecondaryPreviews] = useState([]);
  const [existingSelectedImages, setExistingSelectedImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URL}/products/${id}`);
        if (!res.ok) throw new Error('Erreur chargement produit');
        const data = await res.json();

        setFormData({
          ...data,
          promotion: data.promotion || 0,
          price: data.price || data.prixVente || 0,
          prixOriginal: data.prixOriginal || data.prixVente || data.price || 0,
          stock: data.stock || 0,
          disponible: data.disponible !== undefined ? data.disponible : true,
          nouveaute: data.nouveaute !== undefined ? data.nouveaute : true,
          videoUrl: data.videoUrl || '',
          images: Array.isArray(data.images) ? data.images : [],
        });

        setPreview(
          data.img?.startsWith('http')
            ? data.img
            : `${API_URL}/uploads/${data.img}`
        );

        setExistingSelectedImages(Array.isArray(data.images) ? data.images : []);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
        toast.error('Erreur lors du chargement du produit');
      }
    })();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type) || file.size > 2 * 1024 * 1024) {
      toast.error('Format ou taille invalide (max 2 Mo, jpeg/png/jpg).');
      return;
    }
    setImageFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSecondaryChange = (e) => {
    const files = Array.from(e.target.files).filter(
      (f) =>
        ['image/jpeg', 'image/png', 'image/jpg'].includes(f.type) && f.size <= 2 * 1024 * 1024
    );
    setSecondaryFiles(files);
    setSecondaryPreviews(files.map((f) => URL.createObjectURL(f)));
  };

  const toggleExistingImage = (img) => {
    setExistingSelectedImages((prev) =>
      prev.includes(img) ? prev.filter((i) => i !== img) : [...prev, img]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let imgUrl = formData.img;
      if (imageFile) imgUrl = await uploadToCloudinary(imageFile);

      const uploadedSecondaryUrls = await Promise.all(secondaryFiles.map(uploadToCloudinary));

      const basePrice = Number(formData.price) || 0;
      const promo = Number(formData.promotion) || 0;
      const prixOriginal = promo > 0 ? Number(formData.prixOriginal || basePrice) : basePrice;
      const finalPrice = promo > 0 ? Math.round(prixOriginal - (prixOriginal * promo / 100)) : prixOriginal;

    const payload = {
  reference: formData.reference,
  title: formData.title,
  description: formData.description,
  label: formData.label,
  categorie: formData.categorie,
  groupe: formData.groupe,
  videoUrl: formData.videoUrl,

  // Envoyer le prix de base (celui saisi par l'utilisateur)
  basePrice: Number(formData.price),
  promotion: Number(formData.promotion),
  prixAchat: Number(formData.prixAchat),

  stock: Number(formData.stock),
  disponible: formData.disponible,
  nouveaute: formData.nouveaute,

  img: imgUrl,
  existingImages: existingSelectedImages,
  images: uploadedSecondaryUrls,
};

      const res = await fetch(`${API_URL}/update/products/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error('Erreur lors de la mise à jour');

      toast.success('Article mis à jour avec succès');
      navigate(`/detailArticle/${id}`);
    } catch (err) {
      console.error(err);
      toast.error('Erreur lors de la mise à jour');
    }
  };

  if (loading) return <p>Chargement…</p>;

  return (
    <>
      <Navbar />
      <Toaster position="top-right" reverseOrder={false} />
      <div className="modifier-container">
        <h2>Modifier l'article</h2>
        <form className="form-style" onSubmit={handleSubmit}>
          {[
            ['reference', 'Référence', 'text'],
            ['title', 'Titre', 'text'],
            ['price', 'Prix de vente', 'number'],
            ['prixAchat', 'Prix d’achat', 'number'],
            ['promotion', 'Promotion (%)', 'number'],
            ['label', 'Marque', 'text'],
            ['categorie', 'Catégorie', 'text'],
            ['groupe', 'Groupe', 'text'],
            ['stock', 'Stock', 'number'],
            ['videoUrl', 'URL Vidéo (ex: YouTube)', 'text'],
          ].map(([name, label, type]) => (
            <label key={name}>
              {label}
              <input
                name={name}
                type={type}
                value={formData[name]}
                onChange={handleChange}
                required={name !== 'videoUrl'}
                min={type === 'number' ? 0 : undefined}
              />
            </label>
          ))}

          <label>
            Description
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
              rows={4}
            />
          </label>

          <label>
            Disponible
            <input type="checkbox" name="disponible" checked={formData.disponible} onChange={handleChange} />
          </label>

          <label>
            Nouveauté
            <input type="checkbox" name="nouveaute" checked={formData.nouveaute} onChange={handleChange} />
          </label>

          <label>
            Image principale
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </label>
          {preview && <img src={preview} alt="Aperçu" style={{ maxWidth: 200, marginTop: 10, borderRadius: 8 }} />}

          <div>
            <p>Images secondaires existantes (décochez pour supprimer)</p>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {formData.images.map((img, i) => {
                const src = img.startsWith('http') ? img : `${API_URL}/uploads/${img}`;
                return (
                  <label key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <input type="checkbox" checked={existingSelectedImages.includes(img)} onChange={() => toggleExistingImage(img)} />
                    <img src={src} alt={`Secondaire ${i + 1}`} style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 6, marginTop: 5 }} />
                  </label>
                );
              })}
            </div>
          </div>

          <label>
            Ajouter des images secondaires
            <input type="file" accept="image/*" multiple onChange={handleSecondaryChange} />
          </label>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            {secondaryPreviews.map((src, i) => (
              <img key={i} src={src} alt={`Secondaire ajoutée ${i + 1}`} style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 6 }} />
            ))}
          </div>

          <button type="submit" className="btn-primary" style={{ marginTop: 15 }}>
            Enregistrer
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
}